import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ContentDataTable } from "src/components/Common/ContentDataTable";
import { SectionNoData } from "src/components/Common/SectionNoData";
import { IConfig, IUser } from "src/services/types";
import { getUsers } from "src/services/users-service";
import { columnsUsersToValidate } from "./ColumnsUsersToValidate";
import { toast } from 'react-toastify';
import { SearchTable } from "src/components/Common/SearchTable";
import { Card, CardBody, Col, FormGroup, Input, Row } from "reactstrap";
import { DetailsUserModal } from "../Users/DetailsUserModal";
import { ConfirmValidateModal } from "./ConfirmValidateModal";
import { ConfirmRejectModal } from "./ConfirmRejectModal";
import { ConfirmDeleteModal } from "./ConfirmDeleteModal";
import { GroupModal } from "./GroupModal";
import { NoteModal } from "./NoteModal";
import { OccupationFilter } from "../Users/OccupationFilter";
import { EditUserModal } from "../Users/EditUserModal";
import { IndicatorsUsersSection } from "../Users/IndicatorsUsersSection";
import { GroupFilter } from "../Users/GroupFilter";
import { DropdownActionsSelectedUsers } from "../RejectedUsers/DropdownActionsSelectedUsers";

export const UsersToValidate = () => {
    document.title = "Secure | Users";

  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState<IUser[]>([]);
  const [userSelected, setUserSelected] = useState<IUser | null>(null);
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [config, setConfig] = useState<IConfig>({
      page: 1,
      per_page: 10,
      search: "",
      occupation_id: "",
      group_id: "null",
  });
  const [showValidateModal, setShowValidateModal] = useState(false);
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [showMoveToGroupModal, setShowMoveToGroupModal] = useState(false);
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [activeSelectionMultiple, setActiveSelectionMultiple] = useState(false);
  const [selectedRows, setSelectedRows] = useState<IUser[]>([]);

  const fetchData = async (config: IConfig, forceLastSelected = false) => {
    setIsLoading(true);
    const res = await getUsers(config, null)
    setIsLoading(false);
    if (res.result === 'ok') {
        setTotalRows(res.data.pagination.total);
        setUsers(res.data.data);
        setTotalPage(res.data.pagination.total_pages);
        if(forceUserSelected === 'first') {
          openModal(res.data.data[0], res?.data?.data || []);
        } 
        if(forceUserSelected === 'last' || forceLastSelected) {
          openModal(res.data.data[res.data.data.length - 1], res?.data?.data || []);
        }
        setForceUserSelected(null);
    } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error'});
    }
  }

  const onValidate = async (item: IUser) => {
    setUserSelected(item);
    setShowValidateModal(true);
  }

  const onReject = async (item: IUser) => {
    setUserSelected(item);
    setShowRejectedModal(true);
  }

  const onDelete = async (item: IUser) => {
    setUserSelected(item);
    setShowDeletedModal(true);
  }

  const openModal = async (item: IUser, usersAux: IUser[] = [] ) => {
    setUserSelected(item);
    setShowUserDetailModal(true);
    if(usersAux.length > 0) {
      await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
    }
    if((item?.id == (usersAux.length > 0 ? usersAux[0]?.id : users[0]?.id)) && (config.page == 1)) {
      setButtonPrevDisabled(true);
    } else {
      setButtonPrevDisabled(false);
    }

    if((item?.id == (usersAux.length > 0 ? usersAux[usersAux.length - 1]?.id : users[users.length - 1]?.id)) && (config.page == totalPage)) {
      setButtonNextDisabled(true);
    } else {
      setButtonNextDisabled(false);
    }
  }

  const openNoteModal = async (item: IUser) => {
    setUserSelected(item);
    setShowNoteModal(true);
  }

  const onMoveAGroup = async (item: IUser) => {
    setUserSelected(item);
    setShowMoveToGroupModal(true);
  }

  const refresh = () => {
    fetchData(config);
    setForceRefresh(true);
  }
  
  const handleChangeOccupation = (occupationId: string) => {
    setConfig({ ...config, occupation_id: occupationId, page: 1 });
  }

  const openEditUserModal = async (item: IUser) => {
    setUserSelected(item);
    setShowEditUserModal(true);
  }

  const [forceUserSelected, setForceUserSelected] = useState<'last' | 'first' | null>(null);
  const [buttonNextDisabled, setButtonNextDisabled] = useState(false);
  const [buttonPrevDisabled, setButtonPrevDisabled] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  
  const onPrevUser = async() => {
    setButtonNextDisabled(false);
    const index = users.findIndex(u => u.id === userSelected?.id);
    if (index > 0) {
      setUserSelected(users[index - 1]);
    } else if (config.page > 1) {
      setForceUserSelected('last');
      setShowUserDetailModal(false);
      await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
      setConfig({ ...config, page: config.page - 1 });
    }
    if(index === 1 && config.page === 1) {
      setButtonPrevDisabled(true);
    }
  }
  const onNextUser = async(userId: string, isBeforeAction = false) => {
    const index = users.findIndex(u => u.id === userId);
   
    setButtonPrevDisabled(false);
    if((index !== users.length - 1) && isBeforeAction){
      await fetchData(config);
    }
    if(index == users.length - 1 && isBeforeAction && config.page === totalPage) {
      setShowUserDetailModal(false);
      setUserSelected(null);
      refresh();      
      return;
    }
    if(index == users.length - 1 && isBeforeAction) {
      setForceUserSelected('last');
      setShowUserDetailModal(false);
      await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
      await fetchData(config, true);
      return
    }
    if( index == users.length - 1 && config.page === totalPage) {
      setShowUserDetailModal(false);
      return 
    }
    if (index < users.length - 1) {
      setUserSelected(users[index + 1]);
    } else {
      setForceUserSelected('first');
      setShowUserDetailModal(false);
      await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
      setConfig({ ...config, page: config.page + 1 });
    }
  }

  const handleChangeGroup = (groupId: string) => {
    setConfig({ ...config, group_id: groupId, page: 1 });
  }

  const onActiveSelectionMultiple = () => {
    setActiveSelectionMultiple(!activeSelectionMultiple);
    if(!activeSelectionMultiple) {
      toast('Selection multiple activated', { type: 'info' });
    } else {
      toast('Selection multiple deactivated', { type: 'info' });
      setSelectedRows([]);
    }
  }

  const onRefreshSelectedRows = () => {
    setSelectedRows([]);
    refresh();
  }

  const onSelectUser = (item: IUser) => {
    if(activeSelectionMultiple) {
      if(selectedRows.some(selectedRow => selectedRow.id === item.id)) {
        setSelectedRows(selectedRows.filter(selectedRow => selectedRow.id !== item.id));
      } else {
        setSelectedRows([...selectedRows, item]);
      }
    }
  }

  useEffect(() => {
    fetchData(config);
  }, [config]);

  return (
    <>
      <div className="page-content">
          <IndicatorsUsersSection onRefresh={refresh} setForceRefresh={() => setForceRefresh(false)} forceRefresh={forceRefresh} />
          <h2 className="text-primary mb-3">Users to validate</h2>
          <Card>
            <div className="m-2 text-muted">Filters</div>
            <CardBody className="pt-0">
              <Row className="gap-2">
                <Col sm={3} className="d-flex align-items-center justify-content-start">
                  <OccupationFilter
                    onOccupationChange={handleChangeOccupation}
                    label="Occupation"
                  />
                </Col>
                <Col sm={3} className="d-flex justify-content-start align-items-center" >
                  <GroupFilter
                    onChange={handleChangeGroup}
                    label="Group"
                    defaultWithoutGroup
                  />
                </Col>
                <Col sm={3} className="d-flex align-items-center justify-content-start">
                 
                </Col>
                <Col sm={3} className="d-flex justify-content-start align-items-end" >
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Row className="mb-2">
            <Col sm={6} className="d-flex align-items-center justify-content-start gap-2">
              <div>
                <button
                    type="button"
                    className="btn btn-soft-primary waves-effect waves-light"
                    onClick={refresh}
                >
                    <i className="fas fa-sync-alt"></i> Refresh table
                </button>
              </div>
              <CardBody className="d-flex align-items-center justify-content-start gap-2 border rounded-3 p-2">
                <div>
                  <FormGroup switch className="custom-switch d-flex justify-content-center align-items-center gap-2">
                    <Input
                        type="switch"
                        checked={!!activeSelectionMultiple}
                        onChange={() => {onActiveSelectionMultiple()}}
                        id="customSwitch1"
                    />
                    <label htmlFor="customSwitch1" className="form-check-label text-muted pl-2">
                      Selection multiple
                    </label>
                  </FormGroup>
                </div>
                {
                  activeSelectionMultiple && (
                  <div style={{marginLeft: '10px'}}>
                    <DropdownActionsSelectedUsers 
                      users={selectedRows} 
                      onRefresh={onRefreshSelectedRows}
                      onRemoveSelectedUser={(id) => setSelectedRows(selectedRows.filter(user => user.id !== id))}
                    />
                  </div>
                  )
                }
              </CardBody>
            </Col>
            <Col sm={6} className="d-flex justify-content-end align-items-end" >
                <div className="w-75">
                  <SearchTable 
                      onSearch={(search) => setConfig({ ...config, search, page: 1 })}
                      loading={isLoading && !!config.search}
                      className=""
                  />
                </div>
            </Col>
          </Row>
         
          <ContentDataTable isLoading={isLoading}>
              <DataTable
                  customStyles={{
                    rows: { style: { minHeight: '50px' }},
                    table: { style: { minHeight: '400px'}},
                    cells: { style: { paddingLeft: '8px', paddingRight: '8px' }},
                  }}
                  columns={columnsUsersToValidate(
                    config,
                    activeSelectionMultiple,
                    selectedRows, 
                    onValidate, 
                    onReject, 
                    openModal, 
                    onDelete, 
                    onMoveAGroup, 
                    openNoteModal,
                    openEditUserModal,
                    onSelectUser
                  )}
                  data={users}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  responsive
                  onChangeRowsPerPage={(per_page) => setConfig({ ...config, per_page, page: 1 })}
                  onChangePage={(page) => setConfig({ ...config, page })}
                  paginationDefaultPage={config.page}
                  paginationPerPage={config.per_page}
                  paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  noDataComponent={
                      <SectionNoData
                          onRefresh={() => fetchData(config)}
                          isLoading={isLoading}
                      />
                  }
              />
          </ContentDataTable>
      </div>
      {
        userSelected && 
        <DetailsUserModal
            activeButtonsNextPrev
            show={showUserDetailModal}
            onClose={() => (setUserSelected(null), setShowUserDetailModal(false))}
            userId={userSelected?.id!}
            onPrev={onPrevUser}
            onNext={onNextUser}
            buttonNextDisabled={buttonNextDisabled}
            buttonPrevDisabled={buttonPrevDisabled}
            activeValidateRejectButtons
        />
      }

      <ConfirmValidateModal
          show={showValidateModal}
          onClose={() => setShowValidateModal(false)}
          onRefresh={refresh}
          user={userSelected!}
      />

      <ConfirmRejectModal
          show={showRejectedModal}
          onClose={() => setShowRejectedModal(false)}
          onRefresh={refresh}
          user={userSelected!}
      />

      <ConfirmDeleteModal
          show={showDeletedModal}
          onClose={() => setShowDeletedModal(false)}
          onRefresh={refresh}
          user={userSelected!}
      />

      <GroupModal 
          show={showMoveToGroupModal}
          onClose={() => setShowMoveToGroupModal(false)}
          onRefresh={refresh}
          item={userSelected!}
      />

      <NoteModal 
          show={showNoteModal}
          onClose={() => setShowNoteModal(false)}
          onRefresh={refresh}
          item={userSelected!}
      />

      <EditUserModal 
          show={showEditUserModal}
          onClose={() => setShowEditUserModal(false)}
          onRefresh={refresh}
          item={userSelected!}
      />

    </>
  )
}